import { initSection1Readmore } from './section-1-readmore.js';

/**
 * Carrousel section 1 (home) — défilement par cartes.
 */
function initSection1Carousels() {
    document.querySelectorAll('[data-section1-carousel]').forEach((root) => {
        const track = root.querySelector('[data-section1-carousel-track]');
        const prev = root.querySelector('[data-section1-carousel-prev]');
        const next = root.querySelector('[data-section1-carousel-next]');

        if (!track || !prev || !next) {
            return;
        }

        const step = () => {
            const card = track.querySelector('.section-1__card');
            if (!card) {
                return track.clientWidth * 0.4;
            }
            const styles = window.getComputedStyle(track);
            const gap = parseFloat(styles.columnGap || styles.gap) || 0;

            return card.getBoundingClientRect().width + gap;
        };

        prev.addEventListener('click', () => {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
            track.scrollBy({ left: step(), behavior: 'smooth' });
        });
    });
}

function initHomePage() {
    initSection1Carousels();
    initSection1Readmore();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomePage);
} else {
    initHomePage();
}
